// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__kt2KL","icon":"styles_icon__a37fl","rotate-animation":"styles_rotate-animation__1m68J","title":"styles_title__2voFM"};